import React from 'react'

import { Datagrid, DateField, Pagination, ReferenceField, ReferenceManyField, TextField } from 'react-admin'

import { PolymorphicReferenceField } from 'shared/react-admin'
import { ComponentWithDynamicResourceHeader } from 'dash/shared/molecules/ComponentWithSubheader'
import { ComponentWithSubheader } from 'dash/shared'
import Saas from 'saas/react-admin/resources'
import { StripePlanField } from 'saas/react-admin/components/StripePlanField'

export const ServiceEdit = () => {
  const referenceFieldBasePath = '/admin'

  return (
    <ComponentWithSubheader
      path={['Admin', 'Services']}
      component={() => (
        <Saas.Service.Edit
          editLayoutWrapper={{
            component: ComponentWithDynamicResourceHeader,
            props: { recordAttrForBreadrumb: 'name' },
          }}
        >
          <ReferenceManyField
            label="Subscriptions"
            pagination={<Pagination />}
            perPage={10}
            sort={{ field: 'createdAt', order: 'DESC' }}
            reference="admin/subscription"
            target="serviceId"
            fullWidth
          >
            <Datagrid rowClick={null}>
              <PolymorphicReferenceField
                source="Accountable"
                polymorphicRelationship="accountable"
                link={true}
                referenceFieldBasePath={referenceFieldBasePath}
                resourceBase="admin/"
              >
                <TextField source="name" />
              </PolymorphicReferenceField>
              {/* <ReferenceField
label="Account"
source="accountableId"
reference="Account"
link={(record) => `${referenceFieldBasePath}/account/${record.accountableId}`}
>
<TextField source="name" />
</ReferenceField> */}
              {/* <StripePlanField source="Plan" /> */}
              <ReferenceField
                // {...props}
                label="Plan"
                source="providerKey"
                reference="admin/StripeSubscription"
                link={false}
              >
                <StripePlanField source="Plan" />
              </ReferenceField>
              <PolymorphicReferenceField
                source="Active Members"
                polymorphicRelationship="accountable"
                link={false}
                resourceBase="admin/"
              >
                <TextField source="activeMembershipsCount" />
              </PolymorphicReferenceField>
              <ReferenceField
                label="Paid By"
                source="paidBy.id"
                reference="admin/user"
                link={(record) => `${referenceFieldBasePath}/user/${record.paidBy.id}`}
              >
                <TextField source="name" />
              </ReferenceField>
              <ReferenceField
                label="Created By"
                source="createdBy.id"
                reference="admin/user"
                link={(record) => `${referenceFieldBasePath}/user/${record.createdBy.id}`}
              >
                <TextField source="name" />
              </ReferenceField>
              <DateField source="createdAt" label="Created" />
            </Datagrid>
            {/* <EntryList form={record} /> */}
          </ReferenceManyField>
        </Saas.Service.Edit>
      )}
    />
  )
}
